import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NewPasswordContainer from '../new-password/NewPasswordContainer';
import UsernameContainer from '../username/UsernameContainer';
import WorkflowNavContainer from '../workflow-navigation/WorkflowNavContainer';

const propTypes = {
    validateUsernameUrl: PropTypes.string.isRequired,
    validatePasswordUrl: PropTypes.string.isRequired,
    defaultPassword: PropTypes.string,
    errorMessage: PropTypes.array,
    workflowNavElementId: PropTypes.string
};

class CredentialsContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            usernameIsValid: false,
            passwordIsValid: false
        };
        this.handleUsernameChange = this.handleUsernameChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
    }

    handleUsernameChange(isValid) {
        this.setState({ usernameIsValid: isValid });
    }

    handlePasswordChange(isValid) {
        this.setState({ passwordIsValid: isValid });
    }

    isNextEnabled() {
        return this.state.usernameIsValid && this.state.passwordIsValid;
    }

    render() {
        const {
            validateUsernameUrl,
            validatePasswordUrl,
            defaultPassword,
            errorMessage
        } = this.props;

        var errors = errorMessage.map((err, index) => (
            <div key={index} className="is-warning">
                <p id="error-message" className="asc-form-help">
                    {err.ErrorMessage}
                </p>
            </div>
        ));

        return (
            <div>
                <UsernameContainer
                    validateUrl={validateUsernameUrl}
                    onChange={this.handleUsernameChange}
                />
                <NewPasswordContainer
                    validateUrl={validatePasswordUrl}
                    defaultPassword={defaultPassword}
                    onChange={this.handlePasswordChange}
                />
                {errors}
                <WorkflowNavContainer
                    primaryButtonSubmitEnabled={this.isNextEnabled()}
                    elementId={this.props.workflowNavElementId}
                />
            </div>
        );
    }
}

CredentialsContainer.propTypes = propTypes;
export default CredentialsContainer;
